import React from 'react';
import DynamicAlert from './DynamicAlert';
import { useLanguage } from '../../contexts/LanguageContext';

const truncateText = (str, maxLength = 100) => {
  if (!str || typeof str !== 'string') return str;
  if (str.length > maxLength) {
    return str.substring(0, maxLength).trim() + '........';
  }
  return str;
};

const DeleteAlert = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  itemName,
  itemDescription,
  loading = false,
  confirmText,
  cancelText,
  maxTitleLength = 50,
  maxMessageLength = 120,
  maxItemNameLength = 60,
  maxItemDescLength = 120
}) => {
  const { t } = useLanguage();

  const formattedTitle = truncateText(title || t('confirmDeleteTitle') || "تأكيد الحذف", maxTitleLength);
  const formattedMessage = truncateText(message || t('confirmDeleteText') || "هل أنت متأكد من حذف هذا العنصر؟", maxMessageLength);
  const formattedItemName = truncateText(itemName, maxItemNameLength);
  const formattedItemDescription = truncateText(itemDescription, maxItemDescLength);

  return (
    <DynamicAlert
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={formattedTitle}
      message={formattedMessage}
      itemName={formattedItemName}
      itemDescription={formattedItemDescription}
      warningText={t('cannotUndoAction') || "لا يمكن التراجع عن هذا الإجراء"}
      loading={loading}
      confirmText={confirmText || t('deleteBtn') || "حذف"}
      cancelText={cancelText || t('cancel') || "إلغاء"}
      confirmColor="#dc2626"
      warningColor="#dc2626"
    />
  );
};

export default DeleteAlert;